import type { RouterSettings } from "@versatile-credit-apply/sdk"

import type { StepperConfig, StepRouteMeta } from "@/composition"

import { FlowRoutes } from "@/pages/flow/routes"
import { ErrorRoutes } from "@/router/error-routes"
import { ApplyRoutes } from "@/pages/apply/routes"
import { ResumeRoutes } from "@/pages/resume/routes"
import { TestRoutes } from "@/pages/test/routes"

import type { RouteLocationNormalizedLoaded, RouteRecordRaw } from "vue-router"
import { OhMyBobsRoutes } from "@/pages/ohMyBobs/routes"

declare module "vue-router" {
  interface RouteMeta {
    /**
     * Define the 'next' route that should come
     * after the current.
     *
     * Used by `useNextRoute()`
     */
    next?:
      | string
      | ((route: RouteLocationNormalizedLoaded) => string | Promise<string>)

    /**
     * Indicate the current "step" for the round.
     *
     * The value should be an ID of one of the steps.
     */
    step?: StepRouteMeta

    /**
     * Custom Stepper Configuration
     */
    stepper?: StepperConfig
  }
}

export const Routes: RouteRecordRaw[] = [
  /*
   * Entrypoint
   */
  {
    name: "main",
    path: "/",
    components: {
      layout: () => import("@/components/layout/AuthenticatedLayout.vue"),
    },
    children: [...OhMyBobsRoutes, ...ApplyRoutes],
  },
  ...ErrorRoutes,
  ...FlowRoutes,
  ...ResumeRoutes,
  ...TestRoutes,
]

export const routerSettings: RouterSettings = {
  mode: "standard",
  baseUrl: import.meta.env.BASE_URL,
  routes: Routes,
  generalRouteMappings: {
    exit: "/finish",
  },
}
